// extracted by mini-css-extract-plugin
export default {"background":"QwKK9","overlay":"_31JMk","mobile":"_12mJq"};